import ReactGA from 'react-ga4';

// Configuração específica do eBook
export const EBOOK_INFO = {
  id: "despertar-forca-interior",  // Identificador único do eBook
  name: "O Despertar da Força Interior", // Nome do eBook
  price: 47 // Preço do eBook
};

// Inicializa o GA (chame esta função no seu index.js)
export const initializeGA = () => {
  ReactGA.initialize('G-ZS5FGT638Z', {
    gaOptions: {
      // Envia o ID do eBook como dimensão personalizada
      custom_map: { 'dimension1': 'ebook_id' }
    }
  });
};

// Rastrear visualização da página de vendas
export const trackSalesPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Página de Vendas",
    ebook_id: EBOOK_INFO.id,
  });
};

// Rastrear clique no botão de compra
export const trackPurchaseClick = () => {
  ReactGA.event({
    category: 'Conversão',
    action: 'Clique em Comprar',
    label: EBOOK_INFO.name,
    value: EBOOK_INFO.price,
    ebook_id: EBOOK_INFO.id,
  });
};